import { useEffect, useState } from "react";
import { Box, IconButton } from '@mui/material'
import { Delete } from "@mui/icons-material";
import { StyledTableBody, StyledTableRow, UXDataTableWithoutBody } from '../../../../components/UXDataTable'
import MethodSelection from '../../../../components/MethodSelection'
import ModalTwoButtons from '../../../../components/Modal/ModalTwoButtons'
import ModalMessages from '../../../../components/Modal/ModalSimpleButton'
import { defaultShippingItem, getFacilitiesExternal, StyledTableCellMedium, StyledTableCellSmall, SubTitle, WORK_REQUEST_TYPES_ENUM, getColumnsByRequestType, getWorkRequestSampleKey, ensureSampleHasUniqueId, allowsDuplicateContainers } from '../constants'
import { formatMidasNumber } from '../../../../global'
import { getConvertedCurrentAmount, getOriginalAmount } from "../../shared";
import AddSamples from "./AddSamples";
import LocationField, { filterBySite } from "../../../../components/LocationField";
import WorkRequestContainerManagement from "./WorkRequestContainerManagement";
import ValidatedMidasNumberTextField from "../../../../components/ValidatedMidasNumberTextField";
import { WorkRequestFormAutocomplete, WorkRequestFormInput } from "../WorkRequestFormInput";
import LocateContainer from "./LocateContainer";
import SearchIcon from "@mui/icons-material/Search";
import ModalMethodFacilityExternal from "../ModalMethodFacilityExternal";
import { Warning } from "@mui/icons-material";
import ManageContainerWithoutTests from "./ManageContainerWithoutTests";
import PrintInformation from "../../../../components/PrintInformation";
import PrintLabel from "../../../../api/LIMS/PrintLabel";
import { GlobalButton } from "../../../styles";

const columnName = {
    midas: "MIDAS #",
    container: "Container",
    psimsid: "PSIMS ID",
    uom: "UoM",
    originalAmount: "Original Amt.",
    requestedAmount: "Amt. Requested",
    currentAmount: "Amt. Available",
    location: "Final Location",
    returnLocation: "Test Return Location",
    subLocation: "Final Sublocation",
    blindCodeDescription: "Blind Code Label Description",
    description: "Description",
}

const defaultContainer = {
    sample: null,
    existingContainerID: null,
    requestedAmountUoM: null,
    requestedAmount: null,
    isRequestContainer: true,
};

const labelProp = {
    existingContainerID: 'Container',
    requestedAmountUoM: 'UoM',
    requestedAmount: 'Amt. Requested',
}

const fontSizeInput = 12;

const ContainersAndTestsProcess = ({
    isReadOnly = false,
    mySamplesInfo,
    setMySamplesInfo,
    unitOfMeasureLoading,
    unitOfMeasure,
    shippingRequest,
    setShippingRequest,
    workRequestId,
    setIsRequiredComment,
    isProcess,
    availableLocations,
    prepareData,
    myWorkRequest,
    setMyWorkRequest,
    workRequestFetched,
    withTests,
}) => {
    const [isMySampleInfoModalOpen, setIsMySampleInfoModalOpen] = useState(false);
    const [mySampleInfoToEdit, setMySampleInfoToEdit] = useState(null);

    const [modalDeleteItemOpen, setModalDeleteItemOpen] = useState(false);
    const [modalDeleteItemButton1Text, setModalDeleteItemButton1Text] = useState('');
    const [modalDeleteItemButton2Text, setModalDeleteItemButton2Text] = useState('');
    const [modalDeleteItemTitle, setModalDeleteItemTitle] = useState('');
    const [modalDeleteItemText, setModalDeleteItemText] = useState('');

    const [modalMessagesOpen, setModalMessagesOpen] = useState(false);
    const modalMessagesButtonText = 'Ok'
    const [modalMessagesTitle, setModalMessagesTitle] = useState('');
    const [modalMessagesText, setModalMessagesText] = useState('');

    const [selectedMyContainerIndex, setSelectedMyContainerIndex] = useState(null);
    const [selectedMyContainerIndexToDelete, setSelectedMyContainerIndexToDelete] = useState(null);
    const [methods, setMethods] = useState([]);
    const [containeringMethod, setContaineringMethod] = useState('midas');

    const [triggerRecommendation, setTriggerRecommendation] = useState(false);

    // const [errorsMySamplesInfo, setErrorsMySamplesInfo] = useState([]);

    const [locateContainerIsOpen, setLocateContainerIsOpen] = useState(false);
    const [locateContainerMidas, setLocateContainerMidas] = useState("");
    const [locateContainerOnlySearch, setLocateContainerOnlySearch] = useState(false);

    const [modalFacilityExternalOpen, setModalFacilityExternalOpen] = useState(false);
    const [printLabelInfo, setPrintLabelInfo] = useState(null);
    const [printInfoOpen, setPrintInfoOpen] = useState(false);

    const selectedMyContainer = mySamplesInfo[selectedMyContainerIndex];

    function closeModalMessages() {
        setModalMessagesOpen(false);
    }

    function openModalMessages(title, text) {
        setModalMessagesOpen(true);
        setModalMessagesTitle(title);
        setModalMessagesText(text);
    }

    function openPrintingOptions(sampleList, onlyWithBlindCode) {
        let arrayPrintInfo = [];
        if (sampleList?.length > 0) {
            sampleList.forEach((dataTable) => {
                if (dataTable?.sample && dataTable?.existingContainer) {
                    const containerNumbers = [`${dataTable.existingContainer?.containerNumber}`];
                    let newPrintInfo = new PrintLabel({
                        sampleName: dataTable.sample.sampleName,
                        containerNumbers: containerNumbers,
                        includeAdditionalSampleInformation: false,
                        chemIDOnly: false,
                        printLabelSizeType: null,
                        isBlindCoded: onlyWithBlindCode,
                        blindDescription: null,
                        blindSampleName: null,
                        isShelfLabel: false,
                        shelfLabelText: null,
                        includeShelfBarcode: false
                    });
                    arrayPrintInfo.push(newPrintInfo);
                }
            });
            setPrintLabelInfo(arrayPrintInfo);
            setPrintInfoOpen(true);
        } else {
            openModalMessages('', 'A container needs to be selected to be able to print!');
        }
    }

    function closePrintInformation() {
        setPrintInfoOpen(false);
    }

    // const handleMySampleInfoEditIcon = (mySample) => {
    //     setMySampleInfoToEdit(mySample)
    //     setIsMySampleInfoModalOpen(true)
    // }

    const handleMyContainerDeleteIcon = (index) => {
        openModalDeleteItem("Confirm Deletion", "Are you sure you want to delete this container?  This action cannot be reversed.", "Yes", "No")
        setSelectedMyContainerIndexToDelete(index)
    }

    // const handleMyContainerEditIcon = (myContainer) => {
    //     setMyContainerToEdit(myContainer)
    //     setIsMyContainerModalOpen(true)
    // }

    function openModalDeleteItem(title, text, buttonText, button2Text) {
        setModalDeleteItemButton1Text(buttonText)
        setModalDeleteItemButton2Text(button2Text)
        setModalDeleteItemOpen(true);
        setModalDeleteItemTitle(title);
        setModalDeleteItemText(text);
    }

    function closeModalDeleteItem() {
        if (selectedMyContainerIndexToDelete) {
            setSelectedMyContainerIndexToDelete(null);
            setSelectedMyContainerIndex(null);
        }
        setModalDeleteItemOpen(false);
    }

    function deleteItem() {
        if (selectedMyContainerIndexToDelete || selectedMyContainerIndexToDelete === 0) {
            const selectedMyContainerToDelete = mySamplesInfo[selectedMyContainerIndexToDelete];
            const deletedKey = getWorkRequestSampleKey(selectedMyContainerToDelete);

            setMySamplesInfo([...mySamplesInfo.map(item => ({
                ...item,
                newContainer: null
            })).filter((_, index) => index !== selectedMyContainerIndexToDelete)]);
            setShippingRequest({
                ...shippingRequest,
                shippingItems: shippingRequest.shippingItems.filter(f => f.workRequestSampleKey !== deletedKey)
            })
            openModalMessages('Deleted', 'Container deleted with success!')
        }
        closeModalDeleteItem();
    }

    function onCloseMySampleInfoModal() {
        setIsMySampleInfoModalOpen(false);
        setMySampleInfoToEdit(null);
    }

    useEffect(() => {
        if (workRequestFetched?.testSubmissionJSON) {
            const parsedValue = JSON.parse(workRequestFetched.testSubmissionJSON);
            onChangeMethods(parsedValue.methods ? parsedValue.methods : parsedValue);
            setContaineringMethod(!parsedValue.containeringMethod || parsedValue.containeringMethod === '' ? 'midas' : parsedValue.containeringMethod);
        } else {
            onChangeMethods([])
            setContaineringMethod('midas');
        }

        // const filteredContainer = workRequestFetched
        // .filter(container =>
        //     container?.existingContainer?.containerNumber !== undefined &&
        //     container?.existingContainer?.containerNumber !== null
        // )
        // .map((container, idx) => ({
        //     label: `${container?.sample?.sampleName ? formatMidasNumber(container?.sample?.sampleName) : ''}/${container?.existingContainer?.containerNumber}`,
        //     value: idx
        // }));

        setSelectedMyContainerIndex(filteredContainerOptions.length === 1 ? filteredContainerOptions[0].value : null);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workRequestFetched])

    useEffect(() => {
        if (methods?.length) {
            onChangeMethods(methods);

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [containeringMethod])


    function onChangeMethods(methods) {
        setMethods(methods);
        const methodFiltered = methods.filter((x) => x.methodFacility);
        const updatedTestSubmissionJSON = JSON.stringify({ containeringMethod: containeringMethod, methods: methodFiltered })

        setMyWorkRequest((prev) => ({
            ...prev,
            testSubmissionJSON: updatedTestSubmissionJSON
        }));

        setMySamplesInfo((prevList) => {
            return prevList.map(mySampleInfo => {
                return {
                    ...mySampleInfo,
                    testSubmissionJSON: updatedTestSubmissionJSON,
                    newContainer: mySampleInfo.newContainerID ? mySampleInfo.newContainer : null,
                }
            })
        })
    }

    // const methodFacilitiesExternal = methods.filter(f => f.externalLaboratory);
    // const uniqueFacilitiesExternal = new Set(methodFacilitiesExternal.map(f => f.externalLaboratory?.laboratoryName));

    // const handleChangeErrorMySamplesInfo = (index, field, value) => {
    //     const updatedErrors = [...errorsMySamplesInfo];
    //     updatedErrors[index][field] = value;

    //     setErrorsMySamplesInfo(updatedErrors);
    // }

    const commonProps = {
        setErrors: () => { },
        errors: {},
        margin: 'dense',
        styled: {
            marginRight: "unset",
            marginBottom: "unset",
        }
    }

    const handleChangeMyContainer = (containerIndex, field, value) => {
        const updatedMySampleInfo = [...mySamplesInfo];
        if (!field) {
            updatedMySampleInfo[containerIndex] = value;
        } else {
            updatedMySampleInfo[containerIndex][field] = value;
        }

        if (field === 'sample' && value && !updatedMySampleInfo[containerIndex].existingContainerID &&
            myWorkRequest?.typeName === WORK_REQUEST_TYPES_ENUM.ON_SITE_TRANSPORT) {
            const keyMyContainer = `${value?.sampleName}${updatedMySampleInfo[containerIndex].existingContainerID}`;
            const allMyContainers = [...updatedMySampleInfo.filter(f => `${f.sample?.sampleName}${f.existingContainerID}` !== keyMyContainer), { ...updatedMySampleInfo[containerIndex], sample: value }];
            const containerList = checkDupeContainersShippingRequest(allMyContainers, updatedMySampleInfo[containerIndex], value, value?.containers) ?? [];

            if (containerList.length > 0) {
                const firstContainer = containerList[0];
                let currentContainer = value.containers.find((x) => x.id === firstContainer.existingContainerID);

                updatedMySampleInfo[containerIndex] = {
                    ...updatedMySampleInfo[containerIndex],
                    sample: value,
                    existingContainerID: firstContainer.existingContainerID,
                    requestedAmountUoM: value.requestedAmountUoM ?? currentContainer?.containerSizeUoM,
                    unitOfMeasure: value.unitOfMeasure ?? currentContainer?.uom,
                    existingContainer: currentContainer,
                };
            }
        }

        // Clear newContainer from all entries (but keep all duplicates)
        let finalMySampleInfo = updatedMySampleInfo.map(item => ({
            ...item,
            newContainer: null
        }));

        setMySamplesInfo(finalMySampleInfo);
        const updatedMyContainer = finalMySampleInfo[containerIndex];

        if (updatedMyContainer.isUsedInShipping) {
            const sampleKey = getWorkRequestSampleKey(updatedMyContainer);
            const shippingItem = shippingRequest?.shippingItems?.find(s => s.workRequestSampleKey === sampleKey);
            let newShippingRequest = shippingRequest;

            const newShippingItem = {
                ...defaultShippingItem,
                workRequestSampleKey: sampleKey,
                sampleName: updatedMyContainer?.sample?.sampleName,
                sample: updatedMyContainer?.sample,
                containerID: updatedMyContainer.existingContainerID,
                description: updatedMyContainer?.sample?.description,
                requestedAmountUoM: updatedMyContainer.requestedAmountUoM
            }

            if (shippingItem) {
                newShippingRequest.shippingItems = newShippingRequest.shippingItems.map(item => {
                    if (item.workRequestSampleKey === sampleKey)
                        return newShippingItem;

                    return item;
                })
            } else {
                newShippingRequest.shippingItems.push(newShippingItem);
            }
            setShippingRequest(newShippingRequest);
        } else if (shippingRequest?.shippingItems?.some(s => s.workRequestSampleKey === getWorkRequestSampleKey(updatedMyContainer))) {
            setShippingRequest({
                ...shippingRequest,
                shippingItems: shippingRequest.shippingItems.filter(f => f.workRequestSampleKey !== getWorkRequestSampleKey(updatedMyContainer))
            })
        }
    }

    function checkDupeContainersShippingRequest(allMyContainers, myContainer, sample, containers) {
        if (!containers) return [];

        const confirmedContainers = containers.filter(
            (x) => x.containerStatusName === 'Confirmed'
        );

        // Check if this type allows duplicate containers
        if (!allowsDuplicateContainers(myWorkRequest?.typeName)) {
            // For all other types, filter out already selected containers to prevent duplicates
            const myContainerKey = getWorkRequestSampleKey(myContainer);
            
            // Get container IDs selected by OTHER items (exclude current item).
            // Rows with isRequestContainer === false are extra new containers generated for the same
            // parent container, so they must not make that parent unavailable in the dropdown.
            const selectedContainerIds = allMyContainers
                .filter(c => c.sample?.sampleName === sample?.sampleName
                    && c.isRequestContainer !== false
                    && getWorkRequestSampleKey(c) !== myContainerKey)
                .map(c => c.existingContainerID);

            return confirmedContainers
                .filter(container => !selectedContainerIds.includes(container.id))
                .map(container => ({
                    containerNumber: `${container.containerNumber}`,
                    existingContainerID: container.id
                }));
        }

        return confirmedContainers.map(container => ({
            containerNumber: `${container.containerNumber}`,
            existingContainerID: container.id
        }));
    }

    function handleLocateContainerOpen(open, midas, onlySearch = false) {
        setLocateContainerIsOpen(open)
        setLocateContainerMidas(midas)
        setLocateContainerOnlySearch(onlySearch)
    }

    const facilitiesExternal = getFacilitiesExternal(mySamplesInfo) ?? [];

    const columns = getColumnsByRequestType(myWorkRequest?.typeName, isProcess);

    const renderCell = (column, myContainer, index) => {
        const myContainerKey = getWorkRequestSampleKey(myContainer);
        // Include ALL containers with same sample and containerID (including current one) for available amount calculation
        const containersSameKey = mySamplesInfo.filter(f => 
            f.sample?.sampleName === myContainer.sample?.sampleName && 
            f.existingContainerID === myContainer.existingContainerID
        );
        // Get containers EXCLUDING current one for validation
        const otherContainersSameKey = containersSameKey.filter(f => getWorkRequestSampleKey(f) !== myContainerKey);
        const keepValuesOnChangeContainer = isProcess && !myContainer?.existingContainerID && myContainer?.id ? true : false;

        const allMyContainers = [...mySamplesInfo.filter(f => getWorkRequestSampleKey(f) !== myContainerKey), { ...myContainer }];
        let containerList = checkDupeContainersShippingRequest(allMyContainers, myContainer, myContainer.sample, myContainer.sample?.containers) ?? [];

        // Ensure the currently selected container is always in the list
        if (myContainer.existingContainerID && myContainer.existingContainer) {
            const isCurrentContainerInList = containerList.some(c => c.existingContainerID === myContainer.existingContainerID);
            if (!isCurrentContainerInList) {
                containerList = [
                    {
                        containerNumber: `${myContainer.existingContainer.containerNumber}`,
                        existingContainerID: myContainer.existingContainerID
                    },
                    ...containerList
                ];
            }
        }

        const isOnSiteTransport = myWorkRequest?.typeName === WORK_REQUEST_TYPES_ENUM.ON_SITE_TRANSPORT;

        switch (column) {
            case 'midas':
                return (
                    <StyledTableCellMedium>
                        <ValidatedMidasNumberTextField
                            margin="dense"
                            showLabel={true}
                            fieldWidth="100%"
                            midasNumberObject={myContainer?.sample}
                            setMidasNumberObject={(e) => {
                                if (myContainer?.sample && myContainer?.sample?.sampleName !== e?.sampleName) {
                                    const updatedList = mySamplesInfo.filter((_, idx) => idx !== index);
                                    updatedList.push(ensureSampleHasUniqueId({
                                        ...defaultContainer,
                                        sample: e,
                                        isUsedInShipping: false
                                    }));
                                    setMySamplesInfo(updatedList);
                                } else {
                                    handleChangeMyContainer(index, 'sample', e);
                                }
                            }}
                            setHasErrors={(value) => { }}
                            chemIDToMatch={null}
                            isDisabled={mySampleInfoToEdit || isReadOnly}
                            fontSize={fontSizeInput}
                        />
                    </StyledTableCellMedium>
                );
            case 'container':
                return (
                    <StyledTableCellSmall>
                        <div className="work-request-container-management-input-container">
                            <WorkRequestFormAutocomplete
                                {...commonProps}
                                data={{
                                    ...myContainer,
                                    existingContainerID: !isOnSiteTransport && myContainer.existingContainerID === null && myContainer.sample ?
                                        { existingContainerID: null, containerNumber: ' Any' } : myContainer.existingContainerID
                                }}
                                autoSelect={false}
                                options={isOnSiteTransport ? containerList : [{ existingContainerID: null, containerNumber: ' Any' }, ...containerList]}
                                propertyLabel={'containerNumber'}
                                property={'existingContainerID'}
                                noOptionsText={"No Containers Found"}
                                label={labelProp['existingContainerID']}
                                disabled={myContainer.sample === null || isReadOnly}
                                setData={(data) => {
                                    let currentContainer = myContainer?.sample.containers.find(
                                        (x) => x.id === data.existingContainerID
                                    );
                                    const newMyContainer = {
                                        ...data,
                                        requestedAmount: keepValuesOnChangeContainer ? data.requestedAmount : myContainer?.sample.requestedAmount,
                                        requestedAmountUoM: keepValuesOnChangeContainer ? data.requestedAmountUoM : myContainer?.sample.requestedAmountUoM ?? currentContainer?.containerSizeUoM,
                                        unitOfMeasure: keepValuesOnChangeContainer ? data.unitOfMeasure : myContainer?.sample.unitOfMeasure ?? currentContainer?.uom,
                                        existingContainer: currentContainer,
                                    };

                                    handleChangeMyContainer(index, null, newMyContainer);
                                }}
                                fontSize={fontSizeInput}
                            />
                            {!isReadOnly &&
                                myContainer.sample !== null &&
                                myContainer.sample?.containers.length > 0 && (
                                    <Box display="flex">
                                        <IconButton
                                            type="button"
                                            aria-label="search"
                                            onClick={() => {
                                                myContainer.sample !== null &&
                                                    myContainer.sample?.containers.length > 0
                                                    ? handleLocateContainerOpen(true, myContainer?.sample?.sampleName, (myContainer.sample === null))
                                                    : handleLocateContainerOpen(false, '');
                                            }}
                                        >
                                            <SearchIcon style={{ fill: "blue", fontSize: 24 }} />
                                        </IconButton>
                                    </Box>
                                )}
                            <LocateContainer
                                open={locateContainerIsOpen && locateContainerMidas === myContainer?.sample?.sampleName}
                                setOpen={handleLocateContainerOpen}
                                incomingUoMObject={null}
                                midasNumber={myContainer?.sample?.sampleName}
                                setSelectedContainer={(value) => {
                                    handleChangeMyContainer(index, 'existingContainerID', value);
                                }}
                                updateAllMethods={null}
                                methodInfo={null}
                                allowAllSites={true}
                                onlySearch={locateContainerOnlySearch}
                                defaultSiteName={myWorkRequest.siteName}
                            />
                        </div>
                    </StyledTableCellSmall>
                );
            case 'psimsid':
                return (
                    <StyledTableCellSmall>
                        {myContainer?.sample?.psimsid}
                    </StyledTableCellSmall>
                );
            case 'uom':
                // const defaultUoM = unitOfMeasure.find(uom => uom.uoMName === 'cm3');
                // const useDefaultUoM = myContainer.requestedAmountUoM && myContainer.requestedAmountUoM !== '' ? false : true;
                // if (useDefaultUoM && defaultUoM) {
                //     const newMyContainer = {
                //         ...myContainer,
                //         requestedAmountUoM: defaultUoM?.uoMName,
                //         unitOfMeasure: defaultUoM
                //     };
                //     handleChangeMyContainer(index, null, newMyContainer);
                // }

                return (
                    <StyledTableCellSmall>
                        <WorkRequestFormAutocomplete
                            {...commonProps}
                            data={myContainer}
                            options={unitOfMeasure.map(uom => ({ ...uom, requestedAmountUoM: uom.uoMName }))}
                            unitOfMeasureLoading
                            noOptionsText={
                                unitOfMeasureLoading ? "Loading UoMs..." : "No UoMs Found"
                            }
                            property={'requestedAmountUoM'}
                            propertyLabel={'uoMName'}
                            label={labelProp['requestedAmountUoM']}
                            disabled={myContainer.sample === null || isReadOnly}
                            setData={(data) => {
                                const uom = unitOfMeasure.find(
                                    (x) => x.uoMName === data.requestedAmountUoM
                                );
                                
                                const newMyContainer = {
                                    ...data,
                                    requestedAmount: null,
                                    unitOfMeasure: uom,
                                };
                                handleChangeMyContainer(index, null, newMyContainer);
                            }}
                            fontSize={fontSizeInput}
                        />
                    </StyledTableCellSmall>
                );
            case 'originalAmount':
                return (
                    <StyledTableCellSmall>
                        {getOriginalAmount(myContainer)}
                    </StyledTableCellSmall>
                );
            case 'requestedAmount':
                return (
                    <StyledTableCellSmall>
                        <WorkRequestFormInput
                            {...commonProps}
                            data={myContainer}
                            label={labelProp['requestedAmount']}
                            property="requestedAmount"
                            // validation={(value) => value > 0}
                            setData={(data) => {
                                var numberRegex = /^\d*\.?\d*$/;
                                var requestedAmout = data.requestedAmount?.replace(',', '.');
                                if (
                                    numberRegex.test(requestedAmout) ||
                                    requestedAmout === ""
                                ) {
                                    let value = null;
                                    const currentValue = requestedAmout ? parseFloat(requestedAmout) : null;
                                    
                                    // Validate max amount if container is selected OR if "Any" with UoM
                                    if (myContainer.existingContainerID || (myContainer.requestedAmountUoM && myContainer.requestedAmountUoM !== '')) {
                                        let maxAvailable = 0;
                                        
                                        if (myContainer.existingContainerID) {
                                            // For specific container: get original amount and subtract others manually
                                            const originalAmtStr = getOriginalAmount(myContainer);
                                            const originalAmtValue = originalAmtStr ? parseFloat(originalAmtStr.split(" ")[0]) : 0;
                                            
                                            let totalRequestedByOthers = 0;
                                            otherContainersSameKey.forEach(item => {
                                                const requestedAmount = item.requestedAmount ? parseFloat(item.requestedAmount) : 0;
                                                totalRequestedByOthers += requestedAmount;
                                            });
                                            
                                            maxAvailable = originalAmtValue - totalRequestedByOthers;
                                        } else {
                                            // For "Any": getConvertedCurrentAmount already subtracts containersSameKey
                                            // So we need to add back the current item's amount to get the available for this item
                                            const availableAmtStr = getConvertedCurrentAmount(myContainer, false, containersSameKey, { siteName: myWorkRequest.siteName, locations: availableLocations, requireSiteForAny: true });
                                            const availableAmtValue = availableAmtStr ? parseFloat(availableAmtStr.split(" ")[0]) : 0;
                                            const currentRequestedAmount = myContainer.requestedAmount ? parseFloat(myContainer.requestedAmount) : 0;
                                            
                                            maxAvailable = availableAmtValue + currentRequestedAmount;
                                        }
                                        
                                        if (currentValue || currentValue === 0) {
                                            if (currentValue > maxAvailable) {
                                                value = maxAvailable < 0 ? '0' : maxAvailable.toString();
                                            } else {
                                                value = requestedAmout;
                                            }
                                        }
                                    } else {
                                        // When container is "Any" and no UoM selected, allow any value
                                        value = requestedAmout;
                                    }
                                    
                                    handleChangeMyContainer(index, 'requestedAmount', value);
                                }
                            }}
                            disabled={myContainer.sample === null || isReadOnly}
                            fontSize={fontSizeInput}
                            errors={{
                                requestedAmount: (!myContainer.requestedAmount || (myContainer.requestedAmount && myContainer.requestedAmount <= 0)) && myContainer.sample
                            }}
                        />
                    </StyledTableCellSmall>

                );
            case 'currentAmount':
                return (
                    <StyledTableCellSmall>
                        {(myContainer.requestedAmountUoM && myContainer.requestedAmountUoM !== '') ||
                            myContainer.existingContainerID ?
                            getConvertedCurrentAmount(myContainer, false, containersSameKey, { siteName: myWorkRequest.siteName, locations: availableLocations }) : ''}
                    </StyledTableCellSmall>

                );
            case 'returnLocation':
            case 'location':
                return (
                    <StyledTableCellMedium>
                        <LocationField
                            key={`index-requestedLocationName-${myContainer.requestedLocationName}`}
                            margin="dense"
                            fieldWidth={"100%"}
                            value={myContainer.requestedLocationName}
                            handleChange={(value) => {
                                handleChangeMyContainer(index, 'requestedLocationName', value);
                            }}
                            label={columnName[column]}
                            inputProps={{ style: { fontSize: fontSizeInput } }}
                            shrink={true}
                            isDisabled={isReadOnly}
                            filterLocations={(location) =>
                                filterBySite(location, myWorkRequest.siteName)
                            }
                        />
                    </StyledTableCellMedium>
                );
            case 'subLocation':
                return (
                    <StyledTableCellSmall>
                        <WorkRequestFormInput
                            {...commonProps}
                            label={'Final Sublocation'}
                            property="deliveryLocationSublocation"
                            data={myContainer}
                            setData={(data) => {
                                handleChangeMyContainer(index, null, data);
                            }}
                            fontSize={fontSizeInput}
                            disabled={isReadOnly}
                        />
                    </StyledTableCellSmall>

                );
            case 'blindCodeDescription':
                return (
                    <StyledTableCellMedium>
                        <WorkRequestFormInput
                            {...commonProps}
                            label={'Blind Code Label Description'}
                            property="blindCodeDescription"
                            data={myContainer}
                            setData={(data) => {
                                handleChangeMyContainer(index, null, data);
                            }}
                            fontSize={fontSizeInput}
                            disabled={isReadOnly}
                        />
                    </StyledTableCellMedium>

                );
            case 'description':
                return (
                    <StyledTableCellSmall>
                        {myContainer?.sample?.description}
                    </StyledTableCellSmall>

                );
            default:
                return null;
        }
    };

    // const needContainer = (container) => isProcess && container && !container.existingContainerID;


    const filteredContainerOptions = mySamplesInfo
        .filter(container =>
            container?.existingContainer?.containerNumber !== undefined &&
            container?.existingContainer?.containerNumber !== null
        )
        .map((container, idx) => ({
            label: `${container?.sample?.sampleName ? formatMidasNumber(container?.sample?.sampleName) : ''}/${container?.existingContainer?.containerNumber}`,
            value: idx
        }));

    const filteredMySamplesInfo = mySamplesInfo.filter(mySample => mySample.isRequestContainer);

    isReadOnly = isReadOnly || mySamplesInfo.some(c => c?.newContainerID > 0);

    const sampleWithContainer = mySamplesInfo.filter(f => f.existingContainerID || f.newContainerID);
    const sampleWithoutContainer = filteredMySamplesInfo.filter(f => !f.existingContainerID);
    const hasMissingContainer = sampleWithoutContainer.length > 0;
    const hasContainer = sampleWithContainer.length > 0;

    return (
        <>
            <Box display="flex" flexDirection="column">
                <UXDataTableWithoutBody
                    tableWidth='100%'
                    cols={columns.map(column => (columnName[column]))}
                    blankFirstHeader
                    tableId="myContainerTable"
                    rowLength={filteredMySamplesInfo?.length}
                    noDataFoundMessage={'No container found'}
                    enableAddIcon={!isReadOnly}
                    addToolTipText="Add new"
                    addFunction={() => {
                        const updatedMySampleInfo = [...mySamplesInfo.map(item => ({ ...item, newContainer: null }))];
                        updatedMySampleInfo.push(
                            ensureSampleHasUniqueId({
                                ...defaultContainer,
                                requestedLocationName: myWorkRequest?.typeName === WORK_REQUEST_TYPES_ENUM.CONTAINER_REGISTRATION_TESTS ? 'DISCARD' : null,
                                isUsedInShipping: false
                            })
                        )
                        setMySamplesInfo(updatedMySampleInfo);
                    }}
                >
                    <StyledTableBody>
                        {filteredMySamplesInfo.map((myContainer, index) => {
                            return <StyledTableRow
                                key={index}
                                hover
                            >
                                <StyledTableCellSmall>
                                    <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                                        <IconButton
                                            disabled={isReadOnly}
                                            color="error"
                                            style={{ padding: 0 }}
                                        >
                                            <Delete
                                                fontSize="small"
                                                color="inherit"
                                                onClick={(e) => {
                                                    handleMyContainerDeleteIcon(index)
                                                }}
                                            />
                                        </IconButton>
                                    </Box>
                                </StyledTableCellSmall>
                                {columns.map((col) => {
                                    return renderCell(
                                        col,
                                        myContainer,
                                        index
                                    )
                                })}
                            </StyledTableRow>
                        })}
                    </StyledTableBody>
                </UXDataTableWithoutBody>
            </Box>
            {hasMissingContainer && <div className="sample-safety-warning-external">
                <div>Container must be provided.</div>
                <IconButton
                    color="warning"
                    style={{ padding: 0 }}
                >
                    <Warning
                        fontSize="small"
                        color="inherit"
                    />
                </IconButton>
            </div>}
            {myWorkRequest.typeName === WORK_REQUEST_TYPES_ENUM.SHIPPING && sampleWithContainer.every(s => !s.newContainerID) && (
                <GlobalButton
                    style={{ width: 160, marginBottom: "16px" }}
                    name="printLabelsShipping"
                    variant="contained"
                    disabled={!sampleWithContainer.some(s => s.existingContainerID)}
                    onClick={() => {
                        openPrintingOptions(sampleWithContainer);
                    }}
                >
                    Print labels
                </GlobalButton>
            )}
            {withTests && <Box marginTop={4} marginBottom={2}>
                <MethodSelection
                    width="100%"
                    selectedMethods={methods ?? []}
                    setSelectedMethods={onChangeMethods}
                    showCompletionDate={true}
                    showContainerGrouping={false}
                    incomingTemplate={null}
                    showSearchTemplateName={true}
                    isReadOnly={isReadOnly}
                    showEstimateAndPriority={true}
                    showFinalLocation={false}
                    maxMethodsAllowed={999}
                    unitOfMeasureRequested={selectedMyContainer?.unitOfMeasure}
                    showMinSizeLabel={true}
                    availableUOMs={unitOfMeasure}
                    // customWarning={"***If you have a need to submit a sample for testing that does not meet the minimum volume requirements, please contact the Facility Operations Supervisor. If you have specific containering requirements, please add these requirements in the Comments field.***"}
                />
                {/* {!workRequestId && uniqueFacilitiesExternal?.size > 0 &&
                    <label>This work request will get splitted into another {uniqueFacilitiesExternal?.size} requests
                    </label>} */}
                {/* {facilitiesExternal?.length > 0 && methods.length > 1 && !workRequestId && <div className="sample-safety-warning-external"> */}
                {facilitiesExternal?.length > 0 && !workRequestId && <div className="sample-safety-warning-external">
                    {/* <div>This work request will get splitted into another {facilitiesExternal?.length} requests</div> */}
                    <div>This work request will create one draft shipping request for every EXT facility selected.</div>
                    <IconButton
                        color="warning"
                        style={{ padding: 0 }}
                    >
                        <Warning
                            fontSize="small"
                            color="inherit"
                            onClick={() => setModalFacilityExternalOpen(true)}
                        />
                    </IconButton>
                </div>}
                <ModalMethodFacilityExternal
                    facilitiesExternal={facilitiesExternal}
                    modalOpen={modalFacilityExternalOpen}
                    setModalOpen={setModalFacilityExternalOpen}
                    created={false}
                />
            </Box>}
            {isProcess &&
                withTests &&
                mySamplesInfo.length > 0 &&
                methods.filter((x) => x.methodFacility).length > 0 &&
                hasContainer && 
                !hasMissingContainer &&
                // !needContainer(selectedMyContainer) &&
                (
                    <WorkRequestContainerManagement
                        availableLocations={availableLocations}
                        mySamplesInfo={mySamplesInfo}
                        setMySamplesInfo={setMySamplesInfo}
                        methods={methods}
                        setMethods={onChangeMethods}
                        setContaineringMethod={setContaineringMethod}
                        containeringMethod={containeringMethod}
                        selectedMyContainers={sampleWithContainer}
                        availableUOMs={unitOfMeasure}
                        key={`${selectedMyContainerIndex}`}
                        prepareData={prepareData}
                        myWorkRequest={myWorkRequest}
                        onGetRecommendation={triggerRecommendation}
                        setOnGetRecommendation={setTriggerRecommendation}
                        readOnly={isReadOnly}
                    />
                )
            }
            {
                !withTests &&
                myWorkRequest.typeName !== WORK_REQUEST_TYPES_ENUM.MISCELLANEOUS_REQUEST &&
                myWorkRequest.typeName !== WORK_REQUEST_TYPES_ENUM.ON_SITE_TRANSPORT &&
                mySamplesInfo.length > 0 &&
                mySamplesInfo.filter(f => f.existingContainerID).length > 0 && <>
                    <SubTitle style={{ marginBottom: "16px" }}>
                        Manage Containers
                    </SubTitle>
                    <ManageContainerWithoutTests
                        workRequest={myWorkRequest}
                        setWorkRequest={setMyWorkRequest}
                        mySamplesInfo={sampleWithContainer}
                        setMySamplesInfo={setMySamplesInfo}
                        prepareData={prepareData}
                        isProcess={true}
                        isReadOnly={isReadOnly || mySamplesInfo.filter(f => !f.existingContainerID).length > 0}
                        isShipping={myWorkRequest.typeName === WORK_REQUEST_TYPES_ENUM.SHIPPING}
                    />
                </>
            }
            {isMySampleInfoModalOpen && <AddSamples
                isModalOpen={isMySampleInfoModalOpen}
                setIsModalOpen={setIsMySampleInfoModalOpen}
                setIsModalClose={onCloseMySampleInfoModal}
                mySamplesInfo={mySamplesInfo}
                setMySamplesInfo={setMySamplesInfo}
                mySampleInfoToEdit={mySampleInfoToEdit}
                unitOfMeasureLoading={unitOfMeasureLoading}
                unitOfMeasure={unitOfMeasure}
            />}
            <ModalTwoButtons title={modalDeleteItemTitle} button1Text={modalDeleteItemButton1Text} button1Action={deleteItem} button2Text={modalDeleteItemButton2Text} button2Action={closeModalDeleteItem} open={modalDeleteItemOpen} setOpen={setModalDeleteItemOpen}>
                <label>
                    {modalDeleteItemText}
                </label>

                <div></div>
            </ModalTwoButtons>


            {/* Informational Messages */}
            <ModalMessages title={modalMessagesTitle} buttonText={modalMessagesButtonText} buttonAction={closeModalMessages} open={modalMessagesOpen} setOpen={setModalMessagesOpen}>
                <label>
                    {modalMessagesText}
                </label>
            </ModalMessages>
            <PrintInformation
                open={printInfoOpen}
                setOpen={setPrintInfoOpen}
                button2Action={closePrintInformation}
                button2Text={"Close"}
                printLabelInfo={printLabelInfo}
                isShelfLabel={false}
                useFieldsBlindCode={false}
            ></PrintInformation>
        </>
    )
}

export default ContainersAndTestsProcess
